import type { enBillingSaas } from '../en/billing-saas';

export const idBillingSaas: Record<keyof typeof enBillingSaas, string> = {
  'error.subscriptionReadOnly':
    'Akun sedang dalam mode hanya-baca karena tagihan langganan belum dibayar. Anda tetap bisa melihat data dan menyelesaikan bill yang masih terbuka.',
  'error.moduleNotInPlan': 'Fitur ini tidak termasuk dalam paket langganan Anda.',
  'error.planLimitReached':
    'Batas paket langganan Anda sudah tercapai. Tingkatkan paket untuk menambah lagi.',
  'error.tenantSuspended': 'Akun ini ditangguhkan. Hubungi pemilik usaha atau tim dukungan kami.',

  'subs.nav': 'Langganan & tagihan',

  'subs.title': 'Langganan & tagihan',
  'subs.subtitle': 'Paket, status langganan, pemakaian, dan tagihan Anda dari {product}.',
  'subs.noPermission': 'Peran Anda tidak dapat melihat tagihan langganan.',
  'subs.status.trialing': 'Masa uji coba',
  'subs.status.active': 'Aktif',
  'subs.status.past_due': 'Pembayaran terlambat',
  'subs.status.read_only': 'Hanya-baca',
  'subs.status.suspended': 'Ditangguhkan',
  'subs.status.cancelled': 'Dibatalkan',
  'subs.complimentary': 'Lisensi gratis',
  'subs.complimentaryDesc':
    'Akun Anda memakai lisensi gratis: tanpa tagihan dan tidak ada yang perlu dibayar.',
  'subs.planTitle': 'Paket & status',
  'subs.planDesc': 'Harga belum termasuk PPN. Tagihan diterbitkan sebelum setiap periode dimulai.',
  'subs.pricePerMonth': '{price} / bulan',
  'subs.pricePerYear': '{price} / tahun',
  'subs.trialEnds': 'Uji coba berakhir',
  'subs.periodEnds': 'Dibayar hingga',
  'subs.balanceDue': 'Jumlah terutang',
  'subs.readOnlyAt': 'Hanya-baca mulai',
  'subs.suspendedAt': 'Ditangguhkan mulai',
  'subs.noPeriod': 'Belum ada periode berbayar',
  'subs.usageTitle': 'Pemakaian',
  'subs.usageDesc': 'Pemakaian saat ini dibandingkan batas paket Anda.',
  'subs.usage.branches': 'Cabang aktif',
  'subs.usage.staff': 'Akun staf',
  'subs.usage.devices': 'Perangkat aktif',
  'subs.usage.of': '{used} dari {max}',
  'subs.usage.unlimited': '{used} · tanpa batas',
  'subs.modulesTitle': 'Fitur yang termasuk',
  'subs.module.pos': 'Kasir (POS)',
  'subs.module.kds': 'Layar dapur',
  'subs.module.service': 'Layanan meja',
  'subs.module.guest_qr': 'Menu QR',
  'subs.module.guest_ordering': 'Pesan mandiri lewat QR',
  'subs.module.inventory': 'Stok',
  'subs.module.procurement': 'Pembelian',
  'subs.module.ap': 'Faktur pemasok',
  'subs.module.approvals': 'Persetujuan',
  'subs.module.budgets': 'Anggaran',
  'subs.module.custom_domain': 'Domain sendiri',
  'subs.module.warehouse': 'Gudang',
  'subs.payTitle': 'Cara membayar',
  'subs.payDesc':
    'Bayar lewat transfer bank dan cantumkan nomor tagihan di berita transfer. Tim kami mencatat pembayaran Anda dan status akun diperbarui otomatis.',
  'subs.bank': 'Bank',
  'subs.accountNumber': 'Nomor rekening',
  'subs.accountName': 'Atas nama',
  'subs.transferNote': 'Berita transfer',
  'subs.bankMissing': 'Rekening tujuan belum diatur. Hubungi tim kami untuk detail pembayaran.',
  'subs.invoicesTitle': 'Tagihan',
  'subs.invoicesDesc': 'Tagihan langganan untuk {tenant}, yang terbaru di atas.',
  'subs.invoicesEmpty':
    'Belum ada tagihan — tagihan pertama terbit seminggu sebelum masa uji coba atau periode berakhir.',
  'subs.col.number': 'Tagihan',
  'subs.col.period': 'Periode',
  'subs.col.total': 'Total',
  'subs.col.due': 'Jatuh tempo',
  'subs.col.status': 'Status',
  'subs.view': 'Lihat',
  'subs.invoice.open': 'Belum dibayar',
  'subs.invoice.overdue': 'Terlambat',
  'subs.invoice.paid': 'Lunas',
  'subs.invoice.void': 'Dibatalkan',
  'subs.period': '{start} – {end}',

  'subs.detail.back': 'Kembali ke tagihan',
  'subs.detail.title': 'Tagihan {number}',
  'subs.detail.heading': 'Tagihan langganan',
  'subs.detail.issuer': 'Dari',
  'subs.detail.customer': 'Ditagihkan kepada',
  'subs.detail.taxId': 'NPWP: {id}',
  'subs.detail.issued': 'Tanggal terbit',
  'subs.detail.due': 'Jatuh tempo',
  'subs.detail.paidOn': 'Lunas pada {date}',
  'subs.detail.description': 'Keterangan',
  'subs.detail.amount': 'Jumlah',
  'subs.detail.line': 'Langganan paket {plan}, {period}',
  'subs.detail.subtotal': 'Subtotal',
  'subs.detail.tax': 'PPN {rate}',
  'subs.detail.total': 'Total',
  'subs.detail.notFound': 'Tagihan ini tidak ditemukan.',

  'subs.banner.trialing':
    'Masa uji coba berakhir {date} ({days} hari lagi). Bayar tagihan agar {product} tetap bisa digunakan tanpa jeda.',
  'subs.banner.trialingToday':
    'Masa uji coba berakhir hari ini. Bayar tagihan agar {product} tetap bisa digunakan tanpa jeda.',
  'subs.banner.past_due':
    'Pembayaran langganan sudah lewat jatuh tempo. Bayar tagihan sebelum akun menjadi hanya-baca.',
  'subs.banner.read_only':
    'Akun dalam mode hanya-baca karena tagihan langganan belum dibayar. Anda tetap bisa melihat data dan menyelesaikan bill yang terbuka.',
  'subs.banner.suspended':
    'Akun ditangguhkan karena tagihan langganan belum dibayar. Bayar tagihan untuk mengaktifkannya kembali.',
  'subs.banner.action': 'Lihat tagihan',
  'subs.banner.askOwner': 'Minta pemilik usaha untuk membayar tagihan.',

  'subs.platform.nav': 'Tagihan',
  'subs.platform.title': 'Tagihan langganan',
  'subs.platform.subtitle':
    'Tagihan yang diterbitkan untuk tenant. Catat transfer bank hanya setelah dana terlihat di rekening koran.',
  'subs.platform.filterStatus': 'Status',
  'subs.platform.filterTenant': 'Tenant',
  'subs.platform.all': 'Semua',
  'subs.platform.allTenants': 'Semua tenant',
  'subs.platform.empty':
    'Tidak ada tagihan yang cocok. Tagihan muncul setelah siklus penagihan atau operator menerbitkannya.',
  'subs.platform.col.tenant': 'Tenant',
  'subs.platform.issue': 'Terbitkan tagihan',
  'subs.platform.issueTitle': 'Terbitkan tagihan',
  'subs.platform.issueDesc':
    'Untuk periode berikutnya dari paket tenant (atau paket yang Anda pilih). Setelah dibayar, tenant pindah ke paket tersebut.',
  'subs.platform.plan': 'Paket',
  'subs.platform.planCurrent': 'Paket saat ini',
  'subs.platform.issuing': 'Menerbitkan…',
  'subs.platform.issued': 'Tagihan {number} diterbitkan.',
  'subs.platform.runCycle': 'Jalankan penagihan sekarang',
  'subs.platform.running': 'Menjalankan…',
  'subs.platform.cycleDone':
    'Penagihan selesai: {issued} tagihan terbit, {reminders} pengingat, {transitions} perubahan status.',
  'subs.platform.record': 'Catat pembayaran',
  'subs.platform.recordTitle': 'Catat pembayaran {number}',
  'subs.platform.recordDesc':
    '{tenant} · total {total}. Hanya pembayaran penuh lewat transfer bank; tenant otomatis aktif kembali.',
  'subs.platform.amount': 'Jumlah diterima',
  'subs.platform.paidAt': 'Diterima pada',
  'subs.platform.reference': 'Referensi bank',
  'subs.platform.referenceHint': 'Sesuai yang tertera di rekening koran.',
  'subs.platform.recording': 'Mencatat…',
  'subs.platform.recorded': 'Pembayaran {number} tercatat.',
  'subs.platform.amountMismatch': 'Jumlah harus sama dengan total tagihan ({total}).',
  'subs.platform.void': 'Batalkan',
  'subs.platform.voidTitle': 'Batalkan {number}?',
  'subs.platform.voidDesc': 'Tagihan yang dibatalkan tidak bisa dibayar atau dibuka kembali.',
  'subs.platform.voidReason': 'Alasan',
  'subs.platform.voiding': 'Membatalkan…',
  'subs.platform.voided': 'Tagihan {number} dibatalkan.',
  'subs.platform.noAccess': 'Hanya operator platform yang dapat melihat tagihan langganan.',
};
